module.exports = __webpack_public_path__ + "static/media/pay-by-card.255f284d.svg";